import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { VrLineHeight } from '../../../theming/verticalRhythm/verticalRhythm';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { useTheme } from '../../../theming/useTheme';

const componentConfigurationKey = 'taboola';

interface TaboolaComponentThemeProps {
  vrLineHeight: VrLineHeight
}

type TaboolaComponentProps = TaboolaComponentThemeProps;

const createStyle = (vrLineHeight: VrLineHeight) => {
  return StyleSheet.create({
    style: {
      [MEDIA_BREAKPOINTS.X_LARGE]: {
        paddingTop: `${vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE] * 2}px`,
        paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE]}px`,
        paddingRight: `${vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE]}px`,
      },
      [MEDIA_BREAKPOINTS.LARGE]: {
        paddingTop: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE] * 2}px`,
        paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE]}px`,
        paddingRight: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE]}px`,
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        paddingTop: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM] * 2}px`,
        paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM]}px`,
        paddingRight: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM]}px`,
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        paddingTop: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL] * 2}px`,
        paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL]}px`,
        paddingRight: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL]}px`,
      },
    },
  });
};

export class TaboolaComponent extends React.Component<TaboolaComponentProps> {
  componentDidMount() {
    // @ts-ignore TS2339
    // eslint-disable-next-line no-underscore-dangle
    window._taboola = window._taboola || [];
    // @ts-ignore TS2339
    // eslint-disable-next-line no-underscore-dangle
    window._taboola.push({
      mode: 'thumbnails-c',
      container: 'taboola-below-article-feed',
      placement: 'Below Article Feed',
      target_type: 'mix',
    });
    // @ts-ignore TS2339
    // eslint-disable-next-line no-underscore-dangle
    window._taboola.push({ flush: true });
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { vrLineHeight } = this.props;
    const style = createStyle(vrLineHeight);
    return (
      <ErrorBoundary>
        <div className={css(style.style)} id="taboola-below-article-feed" />
      </ErrorBoundary>
    );
  }
}


const mapThemeToProps = (theme: TaboolaComponentProps) => ({
  vrLineHeight: theme.vrLineHeight,
});

export const Taboola: React.FunctionComponent<{}> = props => {
  const themeContext = useTheme(componentConfigurationKey, mapThemeToProps);
  return <ErrorBoundary><TaboolaComponent {...themeContext} {...props} /></ErrorBoundary>;
};
